import styled from 'styled-components';

export const ContentWrapper = styled.div`
  text-align: left;
  line-height: 1.5;
  counter-reset: section;

  h3 {
    margin: 1em 0;

    &::before {
      counter-increment: section;
      content: counter(section) '. ';
    }
  }

  ol,
  ul {
    padding-left: 1.5em;
    list-style-position: outside;

    & ol,
    & ul {
      margin-left: 1em;
    }
  }
`;
